import styled, {css} from 'styled-components';
import {Link} from 'react-router-dom';

const bannerLayout = css`
  display: block;
`;

export const BannerLink = styled(Link)`
  ${bannerLayout};
`;

export const BannerWrapper = styled.div`
  ${bannerLayout};
`;

export const BannerImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
  cursor: ${p => (p.$isLink ? 'pointer' : 'default')};
`;
